<table class="table table-borderless esg-table">
    <thead>
        <tr>
            <th></th>
            <th>Scope 1</th>
            <th>Scope 2</th>
            <th>Scope 3</th>
            <th>Out of scope</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td class="esg-table-labels">
                <table>
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Energy & processes</td>
                        </tr>
                        <tr>
                            <td>Procurement</td>
                        </tr>
                        <tr>
                            <td>Transport</td>
                        </tr>
                        <tr>
                            <td>Waste & recycling</td>
                        </tr>
                        <tr>
                            <td>Sold products</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>Total</td>
                        </tr>
                    </tfoot>
                </table>
            </td>
            <td
                *ngFor="let scope of [1, 2, 3, 4]"
                class="esg-table-scopes"
            >
                <table>
                    <tr>
                        <td>
                            <app-sustainability-esg-matrix-scope [esgMatrixData]="esgMatrixData" [scopeNumber]="scope"></app-sustainability-esg-matrix-scope>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </tbody>
</table>
